import TYPES from './types'

export default {
  [TYPES.TITLE.GET]: ({ title }) => title
}
